import cn from 'classnames'
import i18next from 'i18next'

import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'

import { getEltCoverageQuartersLabel } from '../../../helpers/getEltCoverageLabel'

import styles from './EltPeriodCell.module.scss'

interface IProps {
  fYear: number | null
  fQuarter?: number | null
  fQuarters?: number[]
}

export const EltPeriodCell = ({ fYear, fQuarter: quarter, fQuarters }: IProps) => {
  const quarters = [
    ...new Set(
      fQuarters ??
        (quarter && quarter >= 1 && quarter <= 4
          ? Array.from({ length: quarter }, (_, index) => index + 1)
          : [])
    ),
  ]
    .filter((value) => Number.isInteger(value) && value >= 1 && value <= 4)
    .sort((a, b) => a - b)
  if (!fYear || !quarters.length) return <span>—</span>
  const isCumulative = quarters.every((value, index) => value === index + 1)
  const quarterLabel = isCumulative
    ? getEltCoverageQuartersLabel(quarters[quarters.length - 1])
    : quarters
        .map((value) =>
          i18next.t('jbp-elt-coverage-quarter').replaceAll('{quarter}', String(value))
        )
        .join(', ')

  const label = (
    <Translation
      span
      text="jbp-elt-coverage-period"
      replaceParams={[
        { key: '{fYear}', value: String(fYear).slice(-2) },
        { key: '{quarters}', value: quarterLabel },
      ]}
    />
  )
  return (
    <Tooltip tipContent={() => <span>{label}</span>}>
      <div className={styles.root}>
        <div className={styles.bars}>
          {[1, 2, 3, 4].map((value) => (
            <span
              key={value}
              className={cn(styles.bar, { [styles.covered]: quarters.includes(value) })}
            />
          ))}
        </div>
        <div>{label}</div>
      </div>
    </Tooltip>
  )
}
